import { render, staticRenderFns } from "./MyPageLiked.vue?vue&type=template&id=d2a30b4c&"
import script from "./MyPageLiked.vue?vue&type=script&lang=ts&"
export * from "./MyPageLiked.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports